// 店舗確認表 共通定数定義

// 小項目タイトルの定数定義
export const SMALL_TITLE_VALUES = {
  ALL: "1",  // 「全体」タブを表す値
} as const;

// 汎用フラグ値の定数定義
export const FLAG_VALUES = {
  EXISTS: "1",     // 存在する（写真あり、コメントあり等）
  NOT_EXISTS: "0", // 存在しない（写真なし、コメントなし等）
} as const;

// 管理者分析の分析タイプ定数
export const ANALYSIS_TYPES = {
  DO_STORE_ANALYSIS: "5",   // DO内個店分析
  STORE_ANALYSIS: "4",      // 個店別分析
} as const;
